// extracted by mini-css-extract-plugin
module.exports = {"loaderModal":"styles_loaderModal__2mxIP","spinner":"styles_spinner__2f2EG"};